import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, OnInit, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatError, MatFormField, MatHint, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { IRequestClientDataDialogResult } from '@app/shared/models/custom/request-client-data-dialog-result';
import { RequestMapper } from '@features/teladoc-events/mappers/request-mapper';
import { EditRequestViewModel } from '@features/teladoc-events/models/ui/edit-request-view-model';
import { ArraySortPipe, ControlErrorDirective, HowdenAskForSelectService, LabelValueComponent } from '@howdeniberia/core-front';

@Component({
  selector: 'howden-request-client-data-edit-dialog',
  templateUrl: './request-client-data-edit-dialog.component.html',
  styleUrls: ['./request-client-data-edit-dialog.component.scss'],
  imports: [
    ReactiveFormsModule,
    CdkScrollable,
    MatDialogTitle,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatHint,
    MatInput,
    MatError,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    MatSelect, MatOption,
    MatDialogActions,
    MatButton,
    MatIcon,
    LabelValueComponent,
    ArraySortPipe,
    ControlErrorDirective
  ]
})
export class RequestClientDataEditDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<RequestClientDataEditDialogComponent>>(MatDialogRef);
  protected data = inject<IRequestClientDataDialogResult>(MAT_DIALOG_DATA);
  private askForSelectSrv = inject(HowdenAskForSelectService);

  model: EditRequestViewModel = new EditRequestViewModel();

  ngOnInit(): void {
    this.loadForm();
  }

  loadForm(): void {
    const obj = this.data.request;
    const isReactivation = this.data.isReactivation;
    this.model.loadFromRequestShortDto(obj, isReactivation);
  }

  public get numbersOK(): boolean {
    const land = this.model.form.get(this.model.C_LANDLINE)?.value;
    const mob = this.model.form.get(this.model.C_MOBILE)?.value;
    const res = new RequestMapper().validateContactNumbers(
      land?.toString(),
      mob?.toString()
    );
    return res;
  }

  /* #endregion */

  clean(): void {
    this.model.form.reset();
  }

  close(save: boolean): void {
    if (save) {
      this.cleanResult();
      this.data.request = new RequestMapper().editRequestViewModelToIRequestShortDto(this.model);
    }
    this.data.ok = save;
    this.dialogRef.close(this.data);
  }

  cleanResult(): void {
    if (this.model.nif !== null) {
      this.model.nif = this.model.nif.trim().replace('-', '').replace(' ', '');
    }
  }
}
